import React from "react";
import { camera_cards } from "../data/cameraCards";
import BackgroundGrid from "../base-components/BackgroundGrid";

const Stack = () => {
    const cardW   = 30;
    const overlap = cardW * 0.475;

    return (
        <div className="flex justify-center w-full -mt-10">
            {camera_cards.map((card, index) => (
                <div
                    key={card.id}
                    className={`
            relative
            bg-cover bg-center
            rounded-[30px]
            text-white
            flex flex-col justify-between
            border-[1px] border-light
            transform skew-y-[15deg]
            transition-transform duration-300
            hover:-translate-y-[70px]
            overflow-hidden
            bg-dark
          `}
                    style={{
                        width:          `${cardW}%`,
                        aspectRatio:    "280/160",
                        marginLeft:     index === 0 ? 0 : `-${overlap}%`,
                        zIndex:         100 - index,
                        boxShadow:      `${20 + index * 5}px 10px 20px rgba(0,0,0,0.2)`,
                    }}
                >
                    <BackgroundGrid
                        gridSize="45px"
                        gridColor="#fff"
                        opacity={0.4}
                        fadeOffset={0.4}
                    />
                    <div className="
                            relative z-10 backdrop-brightness-50 h-full p-4 flex flex-col justify-start
                            lg:gap-y-[0.5vw]
                            xl:gap-y-[1.5vw]
                    ">
                        <p className="text-center text-[1.5vw] font-[900]">{card.title}</p>
                        {index === 0 ? (
                            <p className="mt-4 text-center text-[1vw] font-normal">
                                {card.description}
                            </p>
                        ) : (
                            <div className="flex flex-row h-full items-center">
                                <div className="w-1/2" />
                                <div className="w-1/2 text-right text-[1vw] font-normal">
                                    {card.description}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Stack;
